export const BOOKING_MODAL_CSS = `
  .ljn-booking-modal {
    position: fixed;
    inset: 0;
    z-index: 1000;
    display: grid;
    place-items: center;
    padding: 24px;
  }

  .ljn-booking-modal__overlay {
    position: absolute;
    inset: 0;
    border: 0;
    background:
      radial-gradient(circle at 50% 38%, rgba(201,165,106,0.18), transparent 34%),
      rgba(3, 14, 24, 0.78);
    cursor: pointer;
  }

  .ljn-booking-modal__panel {
    position: relative;
    z-index: 1;
    width: min(760px, 100%);
    background: rgba(250, 250, 248, 0.97);
    border: 1px solid rgba(201, 165, 106, 0.38);
    box-shadow: 0 34px 90px rgba(0, 0, 0, 0.38);
    padding: clamp(28px, 4vw, 46px);
    animation: ljn-booking-in 0.28s ease-out both;
  }

  @keyframes ljn-booking-in {
    from { opacity: 0; transform: translateY(18px) scale(0.98); }
    to { opacity: 1; transform: translateY(0) scale(1); }
  }

  .ljn-booking-modal__close {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 38px;
    height: 38px;
    display: inline-grid;
    place-items: center;
    border: 1px solid rgba(7, 30, 48, 0.14);
    background: transparent;
    color: var(--color-midnight);
    cursor: pointer;
    transition: background 0.18s, color 0.18s, border-color 0.18s;
  }

  .ljn-booking-modal__close:hover {
    background: var(--color-midnight);
    border-color: var(--color-midnight);
    color: var(--color-ivory);
  }

  .ljn-booking-modal__header {
    margin-bottom: 30px;
    padding-right: 44px;
  }

  .ljn-booking-modal__kicker {
    display: block;
    margin-bottom: 8px;
    font-family: var(--font-sans);
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: var(--color-gold);
  }

  .ljn-booking-modal__title {
    font-family: var(--font-serif);
    font-size: clamp(2.15rem, 5vw, 3.7rem);
    font-weight: 300;
    line-height: 1;
    color: var(--color-midnight);
    margin: 0;
  }

  .ljn-booking-modal__subtitle {
    margin-top: 12px;
    font-family: var(--font-sans);
    font-size: 13px;
    color: var(--color-slate);
  }

  .ljn-booking-modal__grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 18px;
  }

  .ljn-booking-field {
    display: grid;
    gap: 8px;
    min-width: 0;
  }

  .ljn-booking-field > span {
    font-family: var(--font-sans);
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--color-midnight);
  }

  .ljn-booking-field__control {
    min-height: 54px;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 0 15px;
    background: var(--color-white);
    border: 1px solid rgba(7, 30, 48, 0.14);
    color: var(--color-gold);
    transition: border-color 0.18s, box-shadow 0.18s;
  }

  .ljn-booking-field__control:focus-within {
    border-color: var(--color-gold);
    box-shadow: 0 0 0 3px rgba(201, 165, 106, 0.15);
  }

  .ljn-booking-field input {
    width: 100%;
    min-width: 0;
    border: 0;
    outline: 0;
    background: transparent;
    color: var(--color-charcoal);
    font-family: var(--font-sans);
    font-size: 15px;
  }

  .ljn-booking-field input::placeholder {
    color: rgba(90, 100, 117, 0.58);
  }

  .ljn-booking-field .flatpickr-input[readonly] {
    cursor: pointer;
  }

  .ljn-booking-modal__submit {
    min-height: 54px;
    align-self: end;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    border: 1px solid var(--color-teal);
    background: var(--color-teal);
    color: var(--color-white);
    font-family: var(--font-sans);
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    cursor: pointer;
    transition: background 0.2s, border-color 0.2s, gap 0.2s;
  }

  .ljn-booking-modal__submit:hover {
    gap: 16px;
    background: var(--color-teal-light);
    border-color: var(--color-teal-light);
  }

  @media (max-width: 640px) {
    .ljn-booking-modal {
      align-items: end;
      padding: 12px;
    }

    .ljn-booking-modal__panel {
      width: 100%;
      max-height: calc(100vh - 24px);
      overflow-y: auto;
      padding: 28px 18px 20px;
    }

    .ljn-booking-modal__header {
      margin-bottom: 24px;
      padding-right: 42px;
    }

    .ljn-booking-modal__grid {
      grid-template-columns: 1fr;
      gap: 14px;
    }
  }

  .flatpickr-calendar.ljn-booking-datepicker {
    border-radius: 0;
    border: 1px solid rgba(201, 165, 106, 0.42);
    box-shadow: 0 24px 70px rgba(7, 30, 48, 0.22);
    font-family: var(--font-sans);
    overflow: hidden;
  }

  .flatpickr-calendar.ljn-booking-datepicker::before,
  .flatpickr-calendar.ljn-booking-datepicker::after {
    display: none;
  }

  .ljn-booking-datepicker .flatpickr-months {
    background: var(--color-midnight);
  }

  .ljn-booking-datepicker .flatpickr-months .flatpickr-month,
  .ljn-booking-datepicker .flatpickr-current-month .flatpickr-monthDropdown-months,
  .ljn-booking-datepicker .flatpickr-current-month input.cur-year {
    color: var(--color-ivory);
    fill: var(--color-ivory);
  }

  .ljn-booking-datepicker .flatpickr-months .flatpickr-prev-month,
  .ljn-booking-datepicker .flatpickr-months .flatpickr-next-month {
    color: var(--color-gold);
    fill: var(--color-gold);
  }

  .ljn-booking-datepicker .flatpickr-weekdays {
    background: var(--color-midnight);
  }

  .ljn-booking-datepicker span.flatpickr-weekday {
    color: rgba(245, 242, 236, 0.72);
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .ljn-booking-datepicker .flatpickr-day {
    border-radius: 0;
    color: var(--color-charcoal);
  }

  .ljn-booking-datepicker .flatpickr-day.today {
    border-color: var(--color-gold);
  }

  .ljn-booking-datepicker .flatpickr-day.selected,
  .ljn-booking-datepicker .flatpickr-day.startRange,
  .ljn-booking-datepicker .flatpickr-day.endRange,
  .ljn-booking-datepicker .flatpickr-day.selected:hover {
    background: var(--color-teal);
    border-color: var(--color-teal);
    color: var(--color-white);
  }

  .ljn-booking-datepicker .flatpickr-day:hover {
    background: var(--color-ivory);
    border-color: var(--color-ivory);
  }

  .ljn-booking-datepicker .flatpickr-day.flatpickr-disabled,
  .ljn-booking-datepicker .flatpickr-day.flatpickr-disabled:hover {
    color: rgba(90, 100, 117, 0.28);
  }
`
